export default {
	getPasswordValidityPeriod (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'system_setting/password_validity_period/one', params)
	},
	updatePasswordValidityPeriod (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'system_setting/password_validity_period/update', params)
	},
	downloadStaffCsv (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'system_setting/staff_csv/download', params, { responseType: 'blob' })
	}
}



// WEBPACK FOOTER //
// ./src/api/SystemSetting.js